import { render } from "./UnboxFilterSort.vue?vue&type=template&id=fe3fb800&scoped=true"
import script from "./UnboxFilterSort.vue?vue&type=script&lang=js"
export * from "./UnboxFilterSort.vue?vue&type=script&lang=js"

import "./UnboxFilterSort.vue?vue&type=style&index=0&id=fe3fb800&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe3fb800"]])

export default __exports__